import { useState, useEffect } from 'react';
import axios from 'axios';
import { LARAVEL_API_PATH } from '../constants/path';

const CACHE_KEY = 'available_consent_types';
const CACHE_DURATION = 1000 * 60 * 60; // 1 час

interface CachedData {
    types: string[];
    timestamp: number;
}

export const useAvailableConsentTypes = () => {
    const [availableTypes, setAvailableTypes] = useState<string[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAvailableTypes = async () => {
            try {
                // Проверяем кэш
                const cached = localStorage.getItem(CACHE_KEY);
                if (cached) {
                    const cachedData: CachedData = JSON.parse(cached);
                    const isExpired = Date.now() - cachedData.timestamp > CACHE_DURATION;
                    
                    if (!isExpired) {
                        setAvailableTypes(cachedData.types);
                        setLoading(false);
                        return;
                    }
                }

                // Делаем запрос к API
                const response = await axios.get(
                    `${LARAVEL_API_PATH}consent-download/types/available`
                );

                if (response.data?.available_types) {
                    const types = response.data.available_types;
                    setAvailableTypes(types);
                    
                    // Сохраняем в кэш
                    const cacheData: CachedData = {
                        types,
                        timestamp: Date.now()
                    };
                    localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
                }
            } catch (error) {
                console.error('Error fetching available consent types:', error);
                // В случае ошибки используем пустой массив
            } finally {
                setLoading(false);
            }
        };

        fetchAvailableTypes();
    }, []);

    const isTypeAvailable = (type: string): boolean => {
        return availableTypes.includes(type);
    };

    return { availableTypes, loading, isTypeAvailable };
};

